import { CONTENT_TYPE_SLUGS } from "@/helpers/constants";

export default {
  /**
   * Get room state
   * @param state {Object}
   * @param getters {Object}
   * @return {Object[]}
   */
  roomState: state => {
    return state.deState;
  },

  /**
   * Get list of rooms for Digital Event
   * @param state {Object}
   * @return {*}
   */
  rooms: (state, getters, rootState) => {
    return rootState.event.context ? rootState.event.context.children[CONTENT_TYPE_SLUGS.DIGITAL_EVENT_ROOM] || [] : [];
  },
  /**
   * Get list of rooms with params for multiple rooms
   * @param state {Object}
   * @return {*}
   */
  multipleRooms: state => {
    return state.rooms;
  },
  /**
   * Is there only one room
   * @param state {Object}
   * @return {*}
   */
  isSingleRoom: state => {
    return state.rooms.length === 1;
  },

  /**
   * Get room by uuid
   * @param state {Object}
   * @param getters {Object}
   * @return {*}
   */
  room: (state, getters) => uuid => {
    return getters.rooms.find(room => room.uuid === uuid) || null;
  },

  /**
   * Get room by tableUUID
   * @param state {Object}
   * @param getters {Object}
   * @return {function(*=): *}
   */
  roomByTableUUID: (state, getters, rootState, rootGetters) => tableUUID => {
    return getters.rooms.find(room => {
      return rootGetters["tables/tables"](room).find(table => table.uuid === tableUUID);
    });
  },

  /**
   * Get active room
   * @param state {Object}
   * @param getters {Object}
   * @return {*}
   */
  activeRoom: (state, getters) => {
    return getters.rooms.find(room => room.SLUG === state.activeRoom) || getters.defaultRoom;
  },

  defaultRoom: (state, getters) => {
    let defaultRoom = getters.multipleRooms.find(room => room.room_is_default);
    return defaultRoom ? getters.rooms.find(room => room.uuid === defaultRoom.uuid) : getters.rooms[0];
  },

  /**
   * Get Sponsor Profile Lists for active Room
   * @param state {Object}
   * @param getters {Object}
   * @return {function(): *}
   */
  sponsors: (state, getters) => {
    return getters.activeRoom.children[CONTENT_TYPE_SLUGS.SPONSOR_PROFILE_LIST] || [];
  },

  /**
   * Get Sponsor Profile List for main slot
   * @param state {Object}
   * @param getters {Object}
   * @return {function(): *|null}
   */
  mainSponsors: (state, getters) => {
    let sponsors = getters.sponsors;
    return sponsors.length ? sponsors[0] : null;
  },

  /**
   * Get Sponsor Profile List for premium slot
   * @param state {Object}
   * @param getters {Object}
   * @return {function(): *|null}
   */
  premiumSponsors: (state, getters) => () => {
    let sponsors = getters.sponsors;
    return sponsors.length > 1 ? sponsors[1] : null;
  },
  groupTerminology: (state, getters) => {
    const DEFAULT_GROUP_LABEL = "group";
    return getters.activeRoom?.ATTENDEE_GROUPING_TERMINOLOGY
      ? getters.activeRoom.ATTENDEE_GROUPING_TERMINOLOGY.trim()
      : DEFAULT_GROUP_LABEL;
  }
};
